module.exports = __webpack_public_path__ + "img/userCaseNav4.be7b01d5.png";